import { render } from "./CompetitionKeywords.vue?vue&type=template&id=6618ea2e&scoped=true"
import script from "./CompetitionKeywords.vue?vue&type=script&lang=js"
export * from "./CompetitionKeywords.vue?vue&type=script&lang=js"

import "./CompetitionKeywords.vue?vue&type=style&index=0&id=6618ea2e&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6618ea2e"]])

export default __exports__